module.exports = __webpack_public_path__ + "img/default-amount.3c34f5e9.svg";